import { tw } from "@careinfo/tailwind";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import Form from "./Form";

const AddProduct = (props: any) => {
  const { handleCreate, isPostLoading } = props;

  const {
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    register,
    setError,
    watch,
    control,
    formState: { errors },
  } = useForm<any>({
    // resolver: yupResolver(createInventoryInfovalidation),
    defaultValues: {
      is_taxable: true,
    },
  });

  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleCreate(data, setError))}
          className={tw`px-4`}
        >
          <Form
            control={control}
            register={register}
            errors={errors}
            setValue={setValue}
            watch={watch}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <div className={tw`flex w-full justify-end`}>
            <div className={tw`w-24 flex gap-x-4 items-center`}>
              <Button label="Save" isLoading={isPostLoading} />
            </div>
          </div>
        </form>
      </Card>
    </>
  );
};

export default AddProduct;
